import { AxiosError } from "axios";
import useSWR from "swr";
import { useContext } from "react";
import { GetFarmBoost200Response } from "../../../codegen-api";
import { authApi } from "../../../services/api/apiFetcher";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { useLoggerMiddleware } from "../middleware/useLoggerMiddleware";
import { AuthContext } from "../../../contexts/AuthContext";

const FARM_BOOST_API_ENABLED =
  process.env.REACT_APP_ENABLE_FARM_BOOST_API === "true";

export const useFarm = () => {
  const { apiKey, apiSecret } = useContext(AuthContext);
  const fetcher = authApi(apiKey, apiSecret);

  const swr = useSWR<GetFarmBoost200Response, AxiosError>(
    // If apiKey is not available, the request will not fetch
    FARM_BOOST_API_ENABLED && apiKey
      ? [APIEndpointEnum.FARM_BOOST, apiKey]
      : undefined,
    async () => (await (await fetcher.getFarmBoost())()).data,
    {
      use: [useLoggerMiddleware],
      revalidateOnFocus: false,
    }
  );

  return {
    ...swr,
  };
};
